import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
	XThemeForm,
	XSwitch,
	XThemeContainer,
	XThemeDetailsCards,
	XThemeInputText,
	XThemeRadio,
	XThemeSwitchBtn,
	XThemeButton,
	XThemeTable,
	XThemeTag,
	XTag,
} from '../../../../styles/GlobalThemeStyle';
import {
	Row,
	Col,
	Button,
	Input,
	notification,
	Flex,
	Space,
	Table,
	Form,
	Popconfirm,
} from 'antd';
import {
	XThemeTilesCard,
	XThemeVoiceAssCard,
	XThemeVoiceaAsistCard,
	XThemeVoiceAssSeeBtn,
	XThemeVoiceAssTable,
	XThemeVoiceAssTableCard,
	XThemeVoiceAssTitle,
	XThemeVoiceCreateCaseBtn,
	XThemeVoiceaAsistChartCard,
	XThemeVoiceaAssSearchBar,
	XThemeFitToScreen,
	XThemeFixBottom,
	XThemeVoiceaAsistChatCard,
	XThemeVACheckbox,
	XThemeVASubmitBTN,
	XVSLottie,
	XVSLottieWrapper,
	XThemeVSSetViewPort,
	XThemeVSScrollContainer,
	XThemeVSGenerateAL,
	XThemeHeaderBTN,
	XThemeVSDetailsCard,
	XThemeVSPara1,
} from '../../VoiceAssistanceStyle';
import { CalendarOutlined, PlusCircleOutlined } from '@ant-design/icons';
import VSLoaderJson from '../../../../json/AppealLetter.json';
import { XDivider } from '../../../AnalyseCoverage/AnalyseCoverageStyle';
import { Editor } from '@tinymce/tinymce-react';
import config from '../../../../config';

const VAAppealLetterPreview = (props) => {
	const {
		patientData,
		editAppealLetterFromModal,
		previewAppealLetter,
		appealLetterHeader,
		appealLetterContent,
		appealLetterFooter,
		showEditAppealLetter,
		saveAndPreviewAppealLetter,
		editAppealLetterLoading,
		closeEditAppealLetter,
		editorRef,
		setLoading,
		appealLetterType,
	} = props;
	return (
		<>
			<XThemeVSSetViewPort className="displyBlock">
				<XThemeVSScrollContainer>
					<Row gutter={[15, 15]}>
						<Col xs={24} className="mb-3">
							<XThemeVoiceAssTitle>
								Appeal Letter{' '}
								{showEditAppealLetter ? 'Edit' : 'Preview'}
								<br />
								<span>{patientData?.case_id}</span>
							</XThemeVoiceAssTitle>
						</Col>
						{showEditAppealLetter ? (
							<Col xs={24}>
								<XThemeVoiceAssTableCard>
									<Editor
										apiKey={config.tiny_url_key}
										onInit={(evt, editor) =>
											(editorRef.current = editor)
										}
										init={{
											menubar: false,
											plugins: [
												'code',
												'image',
												'link',
												'visualblocks',
											],
											branding: false,
											toolbar:
												'undo redo | formatselect | ' +
												'bold italic backcolor | alignleft aligncenter alignright alignjustify | blocks fontfamily fontsize | ' +
												'bullist numlist outdent indent | image link |' +
												'removeformat | visualblocks code | help ',
											content_style:
												'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
											font_size_formats:
												'8px 10px 12px 14px 18px 24px 36px',
										}}
										initialValue={appealLetterContent}
									/>
									<div className="hasPadding">
										<Col
											xs={24}
											sm={24}
											lg={24}
											className="text-sm-end"
										>
											<Space>
												<XThemeHeaderBTN
													size="large"
													onClick={
														closeEditAppealLetter
													}
												>
													Cancel
												</XThemeHeaderBTN>
												<XThemeHeaderBTN
													size="large"
													onClick={
														saveAndPreviewAppealLetter
													}
													type="primary"
													loading={
														editAppealLetterLoading
													}
												>
													Save and Preview
												</XThemeHeaderBTN>
											</Space>
										</Col>
									</div>
								</XThemeVoiceAssTableCard>
							</Col>
						) : (
							<Col xs={24}>
								<XThemeVoiceAssTableCard>
									<div className="hasPadding">
										<Row
											gutter={[15, 15]}
											className="align-items-center"
										>
											<Col xs={24} sm={12} lg={12}>
												<div
													dangerouslySetInnerHTML={{
														__html: appealLetterHeader,
													}}
												/>
											</Col>
											<Col
												xs={24}
												sm={12}
												lg={12}
												className="text-sm-end"
											>
												<Space>
													<XThemeHeaderBTN
														size="large"
														icon={
															<img
																className="img-fluid"
																src="/images/edit-clinical-icon.svg"
																alt="Edit"
															/>
														}
														onClick={
															editAppealLetterFromModal
														}
													>
														Edit
													</XThemeHeaderBTN>
													<Popconfirm
														title="Re-Generate Appeal Letter"
														placement="bottomRight"
														description="Are you sure to Re-Generate this Appeal Letter?"
														onConfirm={() => {
															setLoading(true);
															previewAppealLetter(
																appealLetterType,
																true,
															);
														}}
														onCancel={() => {
															return;
														}}
														okText="Yes"
														cancelText="No"
														okButtonProps={{
															style: {
																backgroundColor:
																	'#007299',
																borderColor:
																	'#007299',
																color: '#fff',
															},
														}}
													>
														<XThemeHeaderBTN
															size="large"
															icon={
																<img
																	className="img-fluid"
																	src="/images/appeal-letter-regenerate-icon.svg"
																	alt=""
																/>
															}
														>
															Re-Generate
														</XThemeHeaderBTN>
													</Popconfirm>
												</Space>
											</Col>
										</Row>
									</div>
									<XDivider />
									{/* <XThemeVSDetailsCard className="noSpaceCard">
									<Row gutter={[15, 15]}>
										<Col xs={12} sm={12} lg={6}>
											<div className="para">
												<span>Patient :</span>
												Joc Johnson
											</div>
										</Col>
										<Col xs={12} sm={12} lg={6}>
											<div className="para">
												<span>MRN :</span>
												PAT211
											</div>
										</Col>
										<Col xs={12} sm={12} lg={6}>
											<div className="para">
												<span>DOS :</span>
												Dec 12, 2023
											</div>
										</Col>
										<Col xs={12} sm={12} lg={6}>
											<div className="para">
												<span>DOB :</span>
												Mar 9, 1939
											</div>
										</Col>
										<Col xs={12} sm={12} lg={6}>
											<div className="para">
												<span>Visit # :</span>
											</div>
										</Col>
									</Row>
								</XThemeVSDetailsCard> */}
									<div className="hasPadding pt-1">
										<XThemeVSPara1>
											<div
												dangerouslySetInnerHTML={{
													__html: appealLetterContent,
												}}
											/>
										</XThemeVSPara1>
										<XThemeVSPara1 className="mb-0">
											<div
												dangerouslySetInnerHTML={{
													__html: appealLetterFooter,
												}}
											/>
										</XThemeVSPara1>
									</div>
								</XThemeVoiceAssTableCard>
							</Col>
						)}
					</Row>
				</XThemeVSScrollContainer>
			</XThemeVSSetViewPort>
		</>
	);
};

export default VAAppealLetterPreview;
